






import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { Editor as TipTapEditor, EditorContent } from '@tiptap/vue-2';
import Text from '@tiptap/extension-text';
import type { IField, IMergeValues, ITextContentDoc } from '@getaccept/editor-lib';
import { EnterBreakNode, InputDocNode, MergeValueNode, ParagraphNode } from '@getaccept/editor-lib';
import { updateMergeValues, setContent } from './helpers/prosemirror-viewer.helper';

@Component({
  components: {
    EditorContent,
  },
})
export default class ProsemirrorViewerFormOption extends Vue {
  @Prop({ default: '' }) content: ITextContentDoc;
  @Prop({ default: false }) isUpdating: boolean;
  @Prop() mergeValues: IMergeValues;
  @Prop() fields: IField[];

  @Watch('fields')
  @Watch('mergeValues')
  watchMergeValueUpdates() {
    updateMergeValues(this.contentPayload);
  }
  @Watch('content') watchContent() {
    setContent(this.contentPayload);
  }

  viewer: TipTapEditor | null = null;

  get contentPayload() {
    return {
      viewer: this.viewer,
      content: this.content,
      fields: this.fields,
      mergeValues: this.mergeValues,
    };
  }

  get inputViewer() {
    return {
      content: this.content,
      editable: false,
      enableInputRules: false,
      enablePasteRules: false,
      extensions: [InputDocNode, ParagraphNode, Text, MergeValueNode, EnterBreakNode],
    };
  }

  mounted() {
    this.viewer = new TipTapEditor(this.inputViewer);
    updateMergeValues(this.contentPayload);
  }

  beforeDestroy() {
    this.viewer.destroy();
  }
}
